var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.648 1.623a.75.75 0 0 0-1.296 0L5.58 4.667l-3.444.746a.75.75 0 0 0-.4 1.233l2.347 2.627-.355 3.506a.75.75 0 0 0 1.049.761L8 12.12l3.225 1.42a.75.75 0 0 0 1.048-.761l-.355-3.506 2.348-2.627a.75.75 0 0 0-.4-1.233l-3.444-.746-1.774-3.044z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarFilled);
export default ForwardRef;